import { Name } from './styles'

export function EmployeeInformationTitle({ children }) {
  return <Name>{children}</Name>
}
